import UiWiseLayout from 'pages/uiwisePages/UiWiseLayout';
import PropTypes from 'prop-types';
import {createContext, useCallback, useContext, useMemo, useState} from 'react';
import {BUSINESS_ROLE} from '../../../shared/constants/AppConst';
import {isEmpty} from '../CommonUtil';
import {normalizeRole} from '../helper/RouteHelper';

const UiWiseAppContext = createContext();
const UiWiseAppActionContext = createContext();

export const useUiWiseAppContext = () => useContext(UiWiseAppContext);
export const useUiWiseAppActionContext = () =>
  useContext(UiWiseAppActionContext);

const configureRoutes = (route, customRoutes) => {
  if (route.path?.length > 0) {
    customRoutes.push({
      permittedrole: normalizeRole(
        route.permittedrole,
        BUSINESS_ROLE.BUSINESS_ADMIN,
      ),
      path: route.path,
      element: <UiWiseLayout key={route.layoutid} layoutId={route.layoutid} />,
    });
  }
  if (route.children?.length > 0) {
    for (let child of route.children) {
      configureRoutes(child, customRoutes);
    }
  }
};

const UiWiseAppContextProvider = ({children}) => {
  const [uiWiseMenuSpec, setUiWiseMenuSpec] = useState([]);

  // Derive routes from menu specs (memoized)
  const uiWiseRoutes = useMemo(() => {
    if (isEmpty(uiWiseMenuSpec)) return [];

    const routes = [];
    for (const route of uiWiseMenuSpec) {
      configureRoutes(route, routes);
    }
    return routes;
  }, [uiWiseMenuSpec]);

  // update menu specs
  const updateUiWiseMenuSpec = useCallback(
    (menuSpecs) => {
      setUiWiseMenuSpec(menuSpecs);
    },
    [setUiWiseMenuSpec],
  );

  return (
    <UiWiseAppContext.Provider
      value={{
        uiWiseMenuSpec,
        uiWiseRoutes,
      }}
    >
      <UiWiseAppActionContext.Provider
        value={{
          updateUiWiseMenuSpec,
        }}
      >
        {children}
      </UiWiseAppActionContext.Provider>
    </UiWiseAppContext.Provider>
  );
};

export default UiWiseAppContextProvider;

UiWiseAppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
